import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Grid, TextField, CircularProgress } from '@material-ui/core';
const Recommendations = ({}) => {
    return(
        <>
            <Dialog
                open={false}
                onClose={() => console('false')}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    Recommendations
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item md={12}>
                            <div>
                                <h4>Asset: ESN 10001</h4>
                                <p>Titled on MSN 42554 </p>
                            </div>
                            <ul>
                                <li>Send Engine to Shop Visit Right Away</li>
                                <li>Swap the engine with - ESN 1011,ESN 1012, ESN 1013</li>
                                <li>Ground the Engine for 6 Month</li>
                                <li>Titled the Engine on MSN 1001,MSN 1002</li>
                            </ul>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => console('false')} color='primary' size='small' variant='outlined'>No, Choose Other </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Recommendations;